import { formatted } from './utils';
import { Accordion } from '../accordion';
import { cn, IDynamicListItemsProps } from 'types';

export const List = <TData extends Record<string, any>>({
  config,
  data,
  onElementClick,
  accordionChild,
  className = '',
}: IDynamicListItemsProps<TData>) => {
  const handleClick = (row: TData) => {
    if (!row?.disabled && onElementClick) {
      onElementClick(row);
    }
  };

  const renderAccordionChild = (row: TData, rowIdx: number) => {
    if (typeof accordionChild === 'function') {
      return accordionChild(row, rowIdx);
    }
    if (Array.isArray(accordionChild)) {
      return accordionChild[rowIdx] ?? null;
    }
    return accordionChild ?? null;
  };

  const renderRow = (row: TData, rowIdx: number, rowClass?: string) => (
    <div
      className={cn(
        'grid [grid-template-columns:var(--grid-cols)] cursor-pointer hover:bg-blue20',
        rowClass,
        className
      )}
      onClick={() => handleClick(row)}
      key={`row_${rowIdx}`}
    >
      {config?.cols?.map((col, idx) => (
        <span
          className={cn('px-6 py-3 flex items-center', config?.commonCellClassName, col?.cellClassName)}
          key={`item_${col.key || ''}_${idx}`}
        >
          {formatted(col, row[col?.key], row)}
        </span>
      ))}
    </div>
  );

  const renderAccordionRow = (row: TData, rowIdx: number) => {
    const onAccordionClick = () => {
      if (row?.userClosedAccordion) {
        return row?.userClosedAccordion(row);
      }
    };

    return (
      <Accordion
        triggerClassName={cn(
          'px-0 py-0 gap-0 enabled:hover:bg-blue20 border-y-2 border-y-transparent',
          'bg-white aria-expanded:bg-lightGrey aria-expanded:border-b aria-expanded:border-b-neutralGrey'
        )}
        className={cn(
          'border-none rounded-none outline-none overflow-visible',
          '[&_div:has(.tw-accordion-icon-wrapper)]:mr-[1.25rem]',
          className
        )}
        customLabel={renderRow(row, rowIdx)}
        key={`accordion_${rowIdx}`}
        defaultOpen={row?.isAccordionOpen ?? false}
        onClick={() => onAccordionClick()}
      >
        {renderAccordionChild(row, rowIdx)}
      </Accordion>
    );
  };
  return (
    <div className="grid col-span-full divide-y divide-neutralGrey border-t border-neutralGrey">
      {config?.withAccordion
        ? data.map((row: TData, rowIdx: number) => <div key={`row_${rowIdx}`}>{renderAccordionRow(row, rowIdx)}</div>)
        : data.map((row: TData, rowIdx: number) => (
            <div key={`row_${rowIdx}`}>{renderRow(row, rowIdx, 'bg-white')}</div>
          ))}
    </div>
  );
};
